﻿import { createContext, useContext } from "react";
import { APITokenContextType } from "@eaigle/types";

export const APITokenContext = createContext<APITokenContextType | undefined>(undefined);

export const useAPIToken = () => {
  const context = useContext(APITokenContext);
  if (context === undefined) {
    throw new Error("useAPIToken must be used within an APITokenProvider");
  }
  return context;
};
